<div class="tabMainWrapper">
  <div
    (click)="changeTab(i)"
    *ngFor="let tab of tabs; let i = index"
    [attr.data-cy]="'tab-group.component.' + tab.name"
  >
    <span [ngClass]="tabActive === i ? 'tabActive' : 'tabInactive'" [ngStyle]="styles">{{ tab.name }}</span>
  </div>
</div>
